/*eslint-disable*/
import React, {useState, useEffect} from "react";
import { makeStyles } from "@mui/styles";
import Tooltip from "@mui/material/Tooltip";
import { Info, AccountBox, House } from "@mui/icons-material";
import Button from "@mui/material/Button";
import styles from '../../styles/headerLinksStyle.js';
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { 
  Select, MenuItem, Typography, Stack, IconButton, Menu, 
  Fade, Popover, Badge, Avatar, Divider 
} from '@mui/material';
import moment from 'moment/min/moment-with-locales';
import EmailIcon from '@mui/icons-material/Email';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { FONT_FAMILY } from "common/sharedFunctions.js";
import { colors, modernColors } from "components/Theme/WebTheme.js";
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';

const useStyles = makeStyles(styles);

export default function HeaderLinks(props) {
  const classes = useStyles();
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);
  const languagedata = useSelector(state => state.languagedata);
  const { i18n,t } = useTranslation();
  const [loggedIn, setLoggedIn] = useState(false);
  const navigate = useNavigate();

  const [langSelection, setLangSelection] = useState();
  const [multiLanguage, setMultiLanguage] = useState();
  const [langAnchorEl, setLangAnchorEl] = useState(null);
  const openLangMenu = Boolean(langAnchorEl);

  const handleLangClick = (event) => {
    setLangAnchorEl(event.currentTarget);
  };

  const handleLangClose = () => {
    setLangAnchorEl(null);
  };

  const handleLanguageSelect = (index) => {
    i18n.addResourceBundle(multiLanguage[index].langLocale, 'translations', multiLanguage[index].keyValuePairs);
    i18n.changeLanguage(multiLanguage[index].langLocale);
    setLangSelection(index);
    moment.locale(multiLanguage[index].dateLocale);
    handleLangClose();
  };

  useEffect(()=>{
    if(languagedata.langlist){
      for (const key of Object.keys(languagedata.langlist)) {
        if(languagedata.langlist[key].langLocale === i18n.language){
          setLangSelection(key);
        }
      }
      setMultiLanguage(languagedata.langlist);
    }
  },[languagedata.langlist]);

  useEffect(()=>{
    if(auth.profile && auth.profile.uid){
      setLoggedIn(true);
    }else{
      setLoggedIn(false);
    }
  },[auth.profile]);
  
  return (
    <Stack 
      direction={{ xs: "column", md: "row" }} 
      spacing={2} 
      alignItems="center"
      sx={{ height: '100%' }}
    >
      <Button
        variant="text"
        onClick={() => navigate('/')}
        sx={{ 
          color: 'inherit', 
          fontFamily: FONT_FAMILY,
          fontSize: '0.9rem',
          textTransform: 'none',
          fontWeight: 500,
          px: 2,
          py: 1.2,
          borderRadius: '10px',
          transition: 'all 0.3s ease',
          '&:hover': { 
            backgroundColor: 'rgba(255, 193, 7, 0.08)',
            transform: 'translateY(-2px)'
          }
        }}
        startIcon={
          <House 
            fontSize="small" 
            sx={{ 
              transition: 'transform 0.3s ease',
              '.MuiButton-root:hover &': {
                transform: 'translateY(-2px)'
              }
            }} 
          />
        }
      >
        {t('home')}
      </Button>
      
      <Button
        variant="text"
        onClick={() => {
          if(loggedIn){
            navigate('/bookings') 
          } else{
            navigate('/login') 
          }
        }}
        sx={{ 
          color: 'inherit', 
          fontFamily: FONT_FAMILY,
          fontSize: '0.9rem',
          textTransform: 'none',
          fontWeight: 500,
          px: 2,
          py: 1.2,
          borderRadius: '10px',
          transition: 'all 0.3s ease',
          '&:hover': { 
            backgroundColor: 'rgba(255, 193, 7, 0.08)',
            transform: 'translateY(-2px)'
          }
        }}
        startIcon={
          <AccountBox 
            fontSize="small" 
            sx={{ 
              transition: 'transform 0.3s ease',
              '.MuiButton-root:hover &': {
                transform: 'translateY(-2px)'
              }
            }} 
          />
        }
      >
        {loggedIn ? t('myaccount') : t('login_signup')}
      </Button>
      
      <Button
        variant="text"
        onClick={() => navigate('/about-us')}
        sx={{ 
          color: 'inherit', 
          fontFamily: FONT_FAMILY,
          fontSize: '0.9rem',
          textTransform: 'none',
          fontWeight: 500,
          px: 2,
          py: 1.2,
          borderRadius: '10px',
          transition: 'all 0.3s ease',
          '&:hover': { 
            backgroundColor: 'rgba(255, 193, 7, 0.08)',
            transform: 'translateY(-2px)'
          }
        }}
        startIcon={
          <Info 
            fontSize="small" 
            sx={{ 
              transition: 'transform 0.3s ease',
              '.MuiButton-root:hover &': {
                transform: 'translateY(-2px)'
              }
            }} 
          />
        }
      >
        {t('about_us')}
      </Button>
      
      <Button
        variant="text"
        onClick={() => navigate('/contact-us')}
        sx={{ 
          color: 'inherit', 
          fontFamily: FONT_FAMILY,
          fontSize: '0.9rem',
          textTransform: 'none',
          fontWeight: 500,
          px: 2,
          py: 1.2,
          borderRadius: '10px',
          transition: 'all 0.3s ease',
          '&:hover': { 
            backgroundColor: 'rgba(255, 193, 7, 0.08)',
            transform: 'translateY(-2px)'
          }
        }}
        startIcon={
          <Badge color="error" variant="dot" invisible={!loggedIn}>
            <EmailIcon 
              fontSize="small" 
              sx={{ 
                transition: 'transform 0.3s ease',
                '.MuiButton-root:hover &': {
                  transform: 'translateY(-2px)'
                }
              }} 
            />
          </Badge>
        }
      >
        {t('contact_us')}
      </Button>
      
      {/* Dikey Ayırıcı */}
      <Divider orientation="vertical" flexItem sx={{ 
        mx: 0.5, 
        height: '60%', 
        opacity: 0.3,
        display: { xs: 'none', md: 'block' }
      }} />
      
      {/* Sosyal Medya Butonları */}
      <Stack 
        direction="row" 
        spacing={1} 
        sx={{ 
          display: { xs: 'none', md: 'flex' },
          ml: 0 
        }}
      >
        {settings && settings.FacebookHandle && (
          <Tooltip title={t('follow_facebook')} placement="bottom" arrow>
            <IconButton 
              aria-label="facebook" 
              size="small"
              href={settings.FacebookHandle}
              target="_blank"
              sx={{ 
                color: modernColors.textSecondary,
                transition: 'all 0.3s ease',
                '&:hover': { 
                  color: '#4267B2', 
                  backgroundColor: 'rgba(66, 103, 178, 0.1)',
                  transform: 'translateY(-3px)'
                } 
              }}
            >
              <FacebookRoundedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        
        {settings && settings.TwitterHandle && (
          <Tooltip title={t('follow_twitter')} placement="bottom" arrow>
            <IconButton 
              aria-label="twitter" 
              size="small"
              href={settings.TwitterHandle}
              target="_blank"
              sx={{ 
                color: modernColors.textSecondary,
                transition: 'all 0.3s ease',
                '&:hover': { 
                  color: '#1DA1F2', 
                  backgroundColor: 'rgba(29, 161, 242, 0.1)',
                  transform: 'translateY(-3px)'
                } 
              }}
            >
              <TwitterIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        
        {settings && settings.InstagramHandle && (
          <Tooltip title={t('follow_instagram')} placement="bottom" arrow>
            <IconButton 
              aria-label="instagram" 
              size="small"
              href={settings.InstagramHandle}
              target="_blank"
              sx={{ 
                color: modernColors.textSecondary,
                transition: 'all 0.3s ease',
                '&:hover': { 
                  color: '#E1306C', 
                  backgroundColor: 'rgba(225, 48, 108, 0.1)',
                  transform: 'translateY(-3px)'
                } 
              }}
            >
              <InstagramIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Stack>
      
      {/* Dil Seçimi */}
      {multiLanguage && Object.keys(multiLanguage).length > 1 && (
        <>
          <Button
            id="lang-button"
            aria-controls={openLangMenu ? 'lang-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={openLangMenu ? 'true' : undefined}
            onClick={handleLangClick}
            endIcon={<KeyboardArrowDownIcon />}
            sx={{ 
              ml: 0.5,
              color: 'inherit', 
              fontFamily: FONT_FAMILY,
              fontSize: '0.85rem',
              textTransform: 'none',
              fontWeight: 500,
              borderRadius: '8px',
              backgroundColor: 'rgba(0, 0, 0, 0.03)',
              transition: 'all 0.3s ease',
              py: 0.75,
              minWidth: 0,
              px: 1.5,
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.05)',
              }
            }}
          >
            {multiLanguage[langSelection] ? multiLanguage[langSelection].langName : 'Language'}
          </Button>
          <Menu
            id="lang-menu"
            anchorEl={langAnchorEl}
            open={openLangMenu}
            onClose={handleLangClose}
            MenuListProps={{
              'aria-labelledby': 'lang-button',
            }}
            TransitionComponent={Fade}
            transitionDuration={250}
            elevation={3}
            PaperProps={{
              sx: {
                borderRadius: '12px',
                mt: 1.5,
                boxShadow: '0 8px 16px rgba(0,0,0,0.08)'
              }
            }}
          >
            {multiLanguage && Object.keys(multiLanguage).map((key) => (
              <MenuItem 
                key={key} 
                onClick={() => handleLanguageSelect(key)}
                selected={langSelection === key}
                sx={{
                  fontSize: '0.9rem',
                  minWidth: '150px',
                  py: 1,
                  px: 2,
                  borderRadius: '8px',
                  mx: 0.5,
                  my: 0.25,
                  fontFamily: FONT_FAMILY,
                  '&.Mui-selected': {
                    backgroundColor: 'rgba(255, 193, 7, 0.15)',
                  },
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                  '&.Mui-selected:hover': {
                    backgroundColor: 'rgba(255, 193, 7, 0.2)',
                  }
                }}
              >
                <Stack direction="row" spacing={1} alignItems="center">
                  {multiLanguage[key].flag && (
                    <Avatar 
                      src={multiLanguage[key].flag} 
                      alt={multiLanguage[key].langName} 
                      sx={{ 
                        width: 20, 
                        height: 20,
                        mr: 1
                      }} 
                    />
                  )}
                  <Typography sx={{ fontWeight: langSelection === key ? 600 : 400 }}>
                    {multiLanguage[key].langName}
                  </Typography>
                </Stack>
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </Stack>
  );
}
